import {ImageOptimized} from '@/_application/core/components/ui/image';
import {Autoplay, Swiper, SwiperSlide} from '@/_application/core/components/ui/slider';
import {padSingleDigitNumberWithZero} from '@/_application/core/utils/common';
import {useEffect, useMemo, useState} from 'react';
import {SwiperClass} from 'swiper/react';
import {Banner} from '@/__generated__/__types__';
import {getBannerUrlByPath} from '@/_application/helpers/cdn-image';

function HomeBannerSwiperMobile({banners}: {banners: Banner[]}) {
    const [currentSlide, setCurrentSlide] = useState<number>(0);
    const [autoplay, setAutoplay] = useState<boolean>(false);

    const handleSlideChange = (swiper: SwiperClass) => {
        setCurrentSlide(swiper.realIndex);
    };

    const slideNumberDisplay = useMemo(() => {
        if (!banners?.length) return <></>;

        const currentFormatted = padSingleDigitNumberWithZero(currentSlide + 1);
        const totalFormatted = padSingleDigitNumberWithZero(banners.length);
        return `${currentFormatted}/${totalFormatted}`;
    }, [currentSlide, JSON.stringify(banners)]);

    useEffect(() => {
        const handleLoad = () => {
            setAutoplay(true);
            window.removeEventListener('load', handleLoad);
        };

        window.addEventListener('load', handleLoad);

        return () => {
            window.removeEventListener('load', handleLoad);
        };
    }, []);

    return (
        <>
            <Swiper
                modules={[Autoplay]}
                slidesPerView={1}
                autoplay={autoplay ? {delay: 2500, disableOnInteraction: false} : false}
                className="h-full w-full"
                onSlideChange={handleSlideChange}
                loop>
                {banners.map((banner, index) => {
                    return (
                        <SwiperSlide key={banner?.banner_id}>
                            <a href={`${banner?.url_banner}`} target="_self">
                                <div className="z-1 h-[300px] w-full">
                                    <ImageOptimized
                                        className="h-full! w-full object-cover object-bottom"
                                        src={getBannerUrlByPath(banner?.image_mobile!)}
                                        alt={banner?.name ?? 'Banner'}
                                        width={index > 0 ? 768 : 769}
                                        height={index > 0 ? 322 : 323}
                                        quality={100}
                                        loading={index === 0 ? 'eager' : 'lazy'}
                                        priority={index === 0}
                                    />
                                </div>

                                <div
                                    className="h-4 w-full"
                                    style={{
                                        backgroundColor: banner?.background_color as string,
                                    }}
                                />
                            </a>
                        </SwiperSlide>
                    );
                })}
            </Swiper>

            <div className="absolute bottom-14 right-4 z-10 flex w-12 transform items-center justify-center rounded-full bg-KPZ_disable py-0.5 text-xs font-bold text-white">
                {slideNumberDisplay}
            </div>
        </>
    );
}

export default HomeBannerSwiperMobile;
